import PropTypes from 'prop-types'
import React, { Component } from "react"
import withRouter from './Common/withRouter'

class NonAuthLayout extends Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.capitalizeFirstLetter.bind(this)
  }

  capitalizeFirstLetter = string => {
    return string.charAt(1).toUpperCase() + string.slice(2)
  }

  componentDidMount() {
    this.previousTheme = document.documentElement.getAttribute("data-bs-theme");
    this.previousDataTheme = document.documentElement.getAttribute("data-theme");
    this.previousDataThemeMode = document.documentElement.getAttribute("data-theme-mode");
    this.previousClass = document.documentElement.className;
    this.previousBodyBg = document.body.style.backgroundColor;

    document.documentElement.setAttribute("data-bs-theme", "light");
    document.documentElement.setAttribute("data-theme", "light");
    document.documentElement.setAttribute("data-theme-mode", "light");
    document.documentElement.classList.remove('dark');
    document.body.style.backgroundColor = '#f8fafc'; // light mode body bg default
  }

  componentWillUnmount() {
    if (this.previousTheme) {
      document.documentElement.setAttribute("data-bs-theme", this.previousTheme);
    } else {
      document.documentElement.removeAttribute("data-bs-theme");
    }

    if (this.previousDataTheme) {
      document.documentElement.setAttribute("data-theme", this.previousDataTheme);
    } else {
      document.documentElement.removeAttribute("data-theme");
    }

    if (this.previousDataThemeMode) {
      document.documentElement.setAttribute("data-theme-mode", this.previousDataThemeMode);
    } else {
      document.documentElement.removeAttribute("data-theme-mode");
    }

    document.documentElement.className = this.previousClass;
    document.body.style.backgroundColor = this.previousBodyBg;
  }

  render() {
    return <React.Fragment>{this.props.children}</React.Fragment>
  }
}

NonAuthLayout.propTypes = {
  children: PropTypes.any,
  location: PropTypes.object
}

export default withRouter(NonAuthLayout)
